import * as z from "zod";

/**
 * The team whose parcel catalog the selected parcel ids belong to: the
 * delegated fulfillment service team when an automation assigned one,
 * otherwise the store team. Optional only so documents persisted before this
 * field existed still parse.
 */
const parcelCatalogTeamIdSchema = z.string().optional();

const getParcelsForCheckoutFromOmsAutomationResultSchema_ = z.union([
  z.object({
    result: z.literal("converged"),
    selectedParcelIds: z.array(z.string()),
    parcelCatalogTeamId: parcelCatalogTeamIdSchema,
  }),
  z.object({
    result: z.literal("diverged"),
    bestEffortSelectedParcelIds: z.array(z.string()),
    parcelCatalogTeamId: parcelCatalogTeamIdSchema,
  }),
  z.object({
    result: z.literal("learned-preset"),
    selectedParcelIds: z.array(z.string()),
    parcelCatalogTeamId: parcelCatalogTeamIdSchema,
  }),
]);
export const getParcelsForCheckoutFromOmsAutomationResultSchema: z.ZodType<GetParcelsForCheckoutFromOmsAutomationResult> =
  getParcelsForCheckoutFromOmsAutomationResultSchema_;
export type GetParcelsForCheckoutFromOmsAutomationResult = z.infer<
  typeof getParcelsForCheckoutFromOmsAutomationResultSchema_
>;
